export type RoutePresetRow = {
  id: string;
  name: string;
  isActive: boolean;
  /**
   * Una línea por carretera, con su rango entre paréntesis:
   * `C-25 (10+000 → 90+000)`.
   *
   * 🔴 Es el formato de la vista previa del recorrido, que es el criterio de la
   * casa (spec «La carretera del RV: dónde se enseña y dónde estorba»,
   * 2026-08-18): **el rango pegado a su carretera, y nunca un par suelto ni
   * columnas de PK que no dicen de qué vía son**. Los PK de una troncal y su
   * ramal no son comparables —el 235+000 de cada una son dos sitios a 874 m—,
   * así que fundirlos daría un par que no existe en ninguna, y enseñar solo el
   * de la primera oculta las demás.
   *
   * Va en UNA columna, no en tres apiladas como el listado de recorridos: esa
   * tabla comparte sus columnas de PK con el resto de entidades y no podía
   * quitarlas; esta nace ahora, cabe en media pantalla (dos tablas en fila) y
   * cuatro columnas es lo que aguanta.
   */
  roadsLabel: string;
};

export type TableProps = {
  data: {
    activePresets: RoutePresetRow[];
    inactivePresets: RoutePresetRow[];
  };
  onDeactivate: (id: string) => Promise<void>;
  onActivate: (id: string) => Promise<void>;
  /**
   * Abren los modales de SuperModal (patrón de ExternalCompaniesManagementTable
   * y de Equipos): la tabla no ejecuta la acción, solo la pide. El formulario de
   * edición y la confirmación del borrado viven en sus submodales.
   */
  onEditPreset: (preset: RoutePresetRow) => void;
  onDeletePreset: (preset: RoutePresetRow) => void;
};

export type SearchbarFilterTypes = (value: string) => void;

/**
 * Columnas. Se reusan claves que YA existen — la plantilla no necesita
 * vocabulario propio: es un nombre, unas carreteras y sus PK.
 */
export const routePresetsColumnNames = {
  name: {
    id: 'name',
    labelKey: 'tables:headers.name',
  },
  roads: {
    id: 'roads',
    labelKey: 'tables:headers.road',
  },
};
